// material-ui
import { Box } from '@mui/material';
import CheckIcon from "../../assets/images/icons/buttons/checkIcon";

// project import
import getColors from "../utils/getColors";

// assets
// import {CheckSquareFilled, MinusSquareFilled} from '@ant-design/icons';

// ==============================|| RADIO - COLORS ||============================== //

function getColorStyle({ color, theme }) {
	const colors = getColors(theme, color);
	const { lighter, main, dark } = colors;
	
	return {
		'&:hover': {
			backgroundColor: lighter,
			'& .icon': {
				borderColor: '#CFD3D4',
			}
		},
		'&.Mui-checked': {
			'&:hover': {
				color: '#647DFF',
			},
			'& .icon': {
				backgroundColor: '#647DFF',
				borderColor: '#6D7DCD',
			}
		},
		'&.Mui-focusVisible': {
			outline: `2px solid ${dark}`,
			outlineOffset: -4,
		}
	}
}

// ==============================|| CHECKBOX - SIZE STYLE ||============================== //

function getSizeStyle(size) {
	switch (size) {
		case 'small':
			return { size: 24, fontSize: 1.6, position: 2 };
		case 'large':
			return { size: 24, fontSize: 1.6, position: 2 };
		case 'medium':
		default:
			return { size: 24, fontSize: 1.35, position: 2 };
	}
}

// ==============================|| CHECKBOX - STYLE ||============================== //

function checkboxStyle(size) {
	const sizes = getSizeStyle(size);
	
	return {
		'& .icon': {
			width: sizes.size,
			height: sizes.size,
			'& .filled': {
				fontSize: `${sizes.fontSize}rem`,
				top: -sizes.position,
				left: -sizes.position,
				color: '#647DFF',
				borderRadius: '8px',
				border: '1px solid #CFD3D4'
			}
		}
	}
}

// ==============================|| OVERRIDES - CHECKBOX ||============================== //

export default function Checkbox(theme) {
	const { palette } = theme;
	
	return {
		MuiCheckbox: {
			defaultProps: {
				className: 'size-small',
				icon: <Box
					className="icon"
					sx={{
						width: 24,
						height: 24,
						borderColor: 'inherit',
						borderRadius: '8px',
						border: '1px solid #CFD3D4'
					}}
				/>,
				checkedIcon: (
					<Box
						className="icon"
						sx={{
							width: 24,
							height: 24,
							border: '1px solid',
							borderColor: 'inherit',
							borderRadius: '8px',
							position: 'relative',
						}}
					>
						<Box
							sx={{
								width: 22,
								height: 22,
								border: '1px solid',
								borderColor: '#fff',
								borderRadius: '8px',
							}}
						>
							<CheckIcon/>
						</Box>
					</Box>
				),
			},
			styleOverrides: {
				root: {
					borderRadius: 0,
					color: palette.secondary[300],
					'&.size-small': {
						...checkboxStyle('small')
					},
					'&.size-medium': {
						...checkboxStyle('medium')
					},
					'&.size-large': {
						...checkboxStyle('large')
					}
				},
				colorPrimary: getColorStyle({ color: 'primary', theme }),
				colorSecondary: getColorStyle({ color: 'secondary', theme }),
				colorSuccess: getColorStyle({ color: 'success', theme }),
				colorWarning: getColorStyle({ color: 'warning', theme }),
				colorInfo: getColorStyle({ color: 'info', theme }),
				colorError: getColorStyle({ color: 'error', theme })
			}
		}
	};
}
